export default __webpack_public_path__ + "images/e8bc673e0f49706cbb341ec2efeed5b1.svg";